<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<div class="p-2">
  <div class="fw-bold fs-5">Quotes</div>
  <div class="quoteTable quote-list">
    <p-table #pt [value]="quotes" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="quoteId" selectionMode="single"
      [(selection)]="quote" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
      [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped"
      [scrollable]="true" scrollHeight="calc(100vh - 220px)" [responsive]="true">

      <ng-template pTemplate="caption">
        <div class="flex justify-content-between">
          <div class="mr-2">
            <span class="p-input-icon-right">
              <i class="pi pi-search"></i>
              <input #global pInputText type="text" [(ngModel)]="searchName" (input)="pt.filterGlobal($event.target.value, 'contains')"
                placeholder="Search" />
            </span>
          </div>
          <div class="d-block text-end">
            <span>
              <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="50" [dataRetrived]="reservations"
              (exportDataSelected)="exportSelected($event)" importEnabled="false" [sampleFileLink]="sampleLink" [columns]="columns" [importDisabled]="true"></app-import-export>
              <!--clear filters-->
              <button pButton pRipple class="p-button-text"
                style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
              (click)="reloadPage()">Clear Filters</button>
            </span>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th [pSortableColumn]="'quoteVO.quoteIdMask'">Quote ID Mask
            <p-sortIcon [field]="quoteIdMask"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteStatus'">Status
            <p-sortIcon [field]="quoteStatus"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'createDate'">Created
            <p-sortIcon [field]="createDate"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.quoteExpirationDateTime'">Expires
            <p-sortIcon [field]="quoteExpirationDateTime"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.checkInDateTime'">CheckIn
            <p-sortIcon [field]="checkInDateTime"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.checkOutDateTime'">CheckOut
            <p-sortIcon [field]="checkOutDateTime"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.numNights'">Nights
            <p-sortIcon [field]="numNights"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.numAdults'">Adults
            <p-sortIcon [field]="numAdults"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'shortTermRentalVO.propertyCode'">Property
            <p-sortIcon [field]="propertyCode"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'yieldPrice'">List
            <p-sortIcon [field]="yieldPrice"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quotePrice'">Discount$
            <p-sortIcon [field]="quotePrice"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteDiscPct'">Discount%
            <p-sortIcon [field]="quoteDiscPct"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.GuestMasterProfileVO.lastName'">LGuest
            <p-sortIcon [field]="lastName"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.GuestMasterProfileVO.firstName'">FGuest
            <p-sortIcon [field]="firstName"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.GuestMasterProfileVO.emailAddress'">Email
            <p-sortIcon [field]="emailAddress"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.GuestMasterProfileVO.mobilePhone'">Phone
            <p-sortIcon [field]="mobilePhone"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.ReservationistUserVO.lastName'">Reservationist
            <p-sortIcon [field]="reservationistLastName"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.sendEmail'">Email?
            <p-sortIcon [field]="sendEmail"></p-sortIcon>
          </th>
          <th [pSortableColumn]="'quoteVO.sendText'">Text?
            <p-sortIcon [field]="sendText"></p-sortIcon>
          </th>
          <th>Guest View</th>
          <th></th>
        </tr>
        @if (showFilter) {
          <tr>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.quoteIdMask', 'in')"></th>
            <th>
              <p-multiSelect [options]="reservationService.quoteStatuses" optionLabel="name" defaultLabel="Status"
              (onChange)="pt.filter($event.value, 'quoteStatus', 'in')" appendTo="body"></p-multiSelect>
            </th>
            <th><input style="width:100px;" pInputText type="datetime-local" (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
            <th><input style="width:100px;" pInputText type="date" (input)="pt.filter($event.target.value, 'quoteVO.quoteExpirationDateTime', 'in')"></th>
            <th><input style="width:100px;" pInputText type="date" (input)="pt.filter($event.target.value, 'quoteVO.checkInDateTime', 'in')"></th>
            <th><input style="width:100px;" pInputText type="date" (input)="pt.filter($event.target.value, 'quoteVO.checkOutDateTime', 'in')"></th>
            <th><input style="width:80px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.numNights', 'in')"></th>
            <th><input style="width:80px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.numAdults', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>
            <th><input style="width:80px;" pInputText type="text" (input)="pt.filter($event.target.value, 'yieldPrice', 'in')"></th>
            <th><input style="width:80px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quotePrice', 'in')"></th>
            <th><input style="width:80px;" pInputText type="text" (input)="pt.filter($event.target.value ? $event.target.value / 100 : $event.target.value, 'quoteDiscPct', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.GuestMasterProfileVO.lastName', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.GuestMasterProfileVO.firstName', 'in')"></th>
            <th><input style="width:150px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.GuestMasterProfileVO.emailAddress', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.GuestMasterProfileVO.mobilePhone', 'in')"></th>
            <th><input style="width:100px;" pInputText type="text" (input)="pt.filter($event.target.value, 'quoteVO.ReservationistUserVO.lastName', 'in')"></th>
            <th><p-columnFilter type="boolean" field="quoteVO.sendEmail"></p-columnFilter></th>
            <th><p-columnFilter type="boolean" field="quoteVO.sendText"></p-columnFilter></th>
            <th></th>
            <th></th>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="body" let-quote>
        <tr [pSelectableRow]="quote">
          <td>{{quote.quoteIdMask}}</td>
          <td>{{getQuoteStatusName(quote.quoteStatus)}}</td>
          <td>{{quote.createDate | date:'MM/dd/yy HH:MM':'UTC'}}</td>
          <td>{{quote.quoteExpirationDateTime | date:'MM/dd/yy HH:MM':'UTC'}}</td>
          <td>{{quote.checkInDateTime | date:'MM/dd/yyyy':'UTC'}}</td>
          <td>{{quote.checkOutDateTime | date:'MM/dd/yyyy':'UTC'}}</td>
          <td>{{quote.numNights}}</td>
          <td>{{quote.numAdults}}</td>
          <td>{{quote.propertyCode}}</td>
          <td>{{quote.yieldPrice | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{quote.quotePrice | currency : 'USD' : 'symbol' : '1.0-2'}}</td>
          <td>{{quote.quoteDiscPct | percent}}</td>
          <td>{{quote.lastName}}</td>
          <td>{{quote.firstName}}</td>
          <td>{{quote.emailAddress}}</td>
          <td>{{quote.mobilePhone}}</td>
          <td>{{quote.reservationistLastName}}</td>
          <td>{{quote.sendEmail ? 'Yes': 'No'}}</td>
          <td>{{quote.sendText ? 'Yes': 'No'}}</td>
          <td>
            @if (quote.quoteIdMask) {
              <a href="https://www.kbmresorts.com/guest-quote/{{quote.quoteIdMask}}"
                target="_blank" rel="noopener noreferrer"
                title="View as guest: {{quote.quoteIdMask}}">
                <i class="pi pi-external-link" style="color:#E18131; font-size:110%;"></i>
              </a>
            }
          </td>
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit1(quote)"></i>
            </a>
          </span>
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
</div>
